App.namespace.wrap('es6.shared.flash_alert', function (options = {}) {
  const {
    $container,             // Alert will be placed in the beginning of the container
    message,                // Text message
    type,                   // Flash alert type: [success, warning, danger]
    delay = 5000,           // Time in ms after the alert disappears
  } = options

  const FLASH_ALERT_CLASS = 'js-flash-alert'
  const FLASH_ALERT_CLOSE_CLASS = 'js-close-flash-alert'
  const DEFAULT_FADE_OUT_SPEED = 300

  let $alert = null

  const getTemplate = ({ type, message }) => `
    <div class="alert alert-fixed alert-dismissible alert-${type} ${FLASH_ALERT_CLASS}" style="display: none;">
        <button type="button" class="close ${FLASH_ALERT_CLOSE_CLASS}">×</button>
        <p>${message}</p>
    </div>`

  const close = (fadeOutTime = 0) => {
    $alert.fadeOut(fadeOutTime)
    setTimeout(() => {
      $alert.remove()
    }, fadeOutTime)
  }

  const bindCloseButton = () => {
    $(`.${FLASH_ALERT_CLASS}`).on('click', `.${FLASH_ALERT_CLOSE_CLASS}`, close)
  }

  const show = () => {
    const template = getTemplate({ type, message })
    $alert = $(template)
    $alert.prependTo($container).fadeIn()

    bindCloseButton()

    if (delay) {
      setTimeout(close.bind(null, DEFAULT_FADE_OUT_SPEED), delay)
    }
  }

  return {
    show,
  }
});
